// Firebase configuration and initialization
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// Temporarily disable App Check to fix network issues
// import { initializeAppCheck, ReCaptchaV3Provider } from "@firebase/app-check";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDprgGmyardMYaKnRyHuTK59CRJX8twN-8",
  authDomain: "seed-organizr.firebaseapp.com",
  projectId: "seed-organizr",
  storageBucket: "seed-organizr.appspot.com",
  messagingSenderId: "329877944803",
  appId: "1:329877944803:web:612985efa0455cc92fc8d6",
};

console.log("🔥 Firebase initializing for project:", firebaseConfig.projectId);

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

// Configure Auth settings for better network reliability
auth.settings = {
  appVerificationDisabledForTesting: false,
};

// Temporarily disable App Check to resolve network issues
// TODO: Re-enable App Check after resolving auth connectivity
/*
if (process.env.NODE_ENV === "production") {
  initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider(
      process.env.REACT_APP_RECAPTCHA_SITE_KEY || "placeholder-key"
    ),
    isTokenAutoRefreshEnabled: true,
  });
}
*/

console.log("✅ Firebase services initialized successfully");

export { app, auth, db, storage };
